import React, {Component} from 'react';
import { Link } from 'react-router';

class ContactPage extends Component {
    render () {
        const isUS = localStorage.getItem( 'site_of_origin' ).toLowerCase() !== 'us';
        return (
            <div className="row">
                <div className="col-xs-12">
                    <h4 className="h4">Contact</h4>
                    <p className="p-tag">Want to talk...</p>
                    <ul className="contact-details">
                        <li>
                            <i className="fa fa-phone emphasis-background-color"/>
                            <Link to="tel:0161 714 8495">0161&nbsp;714&nbsp;8495</Link>
                        </li>
                        <li>
                            <i className="fa fa-envelope emphasis-background-color"/>
                            <Link to={ `mailto:${ isUS ? 'customercare.us@intouchnetworks.com' : 'customercare@intouchnetworks.com' }` }>{ isUS ? 'customercare.us@intouchnetworks.com' : 'customercare@intouchnetworks.com' }</Link>
                        </li>
                        <li>
                            <i className="fa fa-map-marker emphasis-background-color"/>
                            <address>Floor 4, The Peninsula Building, Manchester, M4 4FB</address>
                        </li>
                        <li>
                            <i className="fa fa-linkedin emphasis-background-color"/>
                            <Link to="https://www.linkedin.com/company-beta/10857465/" target="blank">LinkedIn</Link>
                        </li>
                        <li>
                            <i className="fa fa-twitter emphasis-background-color"/>
                            <Link to="https://twitter.com/intouchnetworks?lang=en" target="blank">@InTouchNetworks</Link>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default ContactPage;


// WEBPACK FOOTER //
// src/client/components/site/features/help/contact/ContactPage.js